import { ButtonBase, Stack, useTheme } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { borderRadius, layoutGap } from '../../../theme/theme';

interface TourStepProgressDotStep {
  readonly id: string;
  readonly title: string;
  readonly phaseLabel?: string;
}

interface TourStepProgressDotsProps {
  readonly steps: readonly TourStepProgressDotStep[];
  readonly stepIndex: number;
  readonly onJumpToStep: (index: number) => void;
}

export const TourStepProgressDots = ({
  steps,
  stepIndex,
  onJumpToStep,
}: TourStepProgressDotsProps) => {
  const theme = useTheme();

  return (
    <Stack
      direction="row"
      spacing={layoutGap.blend}
      alignItems="center"
      useFlexGap
      sx={{ mt: 1, flexWrap: 'wrap', rowGap: 0.55, maxWidth: '100%' }}
    >
      {steps.map((step, index) => (
        <ButtonBase
          key={step.id}
          onClick={() => onJumpToStep(index)}
          aria-label={`Go to tour step ${index + 1}`}
          aria-current={index === stepIndex ? 'step' : undefined}
          title={step.phaseLabel ? `${step.phaseLabel}: ${step.title}` : step.title}
          sx={{
            width: index === stepIndex ? 20 : 10,
            height: 10,
            borderRadius: `${borderRadius.full}px`,
            backgroundColor:
              index === stepIndex
                ? theme.palette.primary.light
                : alpha(theme.palette.common.white, 0.18),
            border: `1px solid ${
              index === stepIndex
                ? alpha(theme.palette.primary.light, 0.42)
                : alpha(theme.palette.divider, 0.12)
            }`,
            transition: 'all 0.18s ease',
          }}
        />
      ))}
    </Stack>
  );
};
